import { type UserInterfaceFlag } from '#app/__generated__/api.js';
import { useCurrentUser } from '#app/hooks/useCurrentUser.js';

/**
 * Given a UserInterfaceFlag or UserInterfaceFlag array, returns a boolean indicating whether the current
 * user has the specific set of userInterfaceFlags(s).
 * @example
 * const hasSeenFTUEModal = useHasUserInterfaceFlags('SEEN_FEED_FTUE_MODAL');
 */
export const useHasUserInterfaceFlags = (
  interfaceFlags: UserInterfaceFlag | UserInterfaceFlag[],
): boolean => {
  const currentUser = useCurrentUser();

  if (!currentUser) return false;

  const currentUserInterfaceFlags = currentUser.userInterfaceFlags;

  if (Array.isArray(interfaceFlags)) {
    return interfaceFlags.every((group) =>
      currentUserInterfaceFlags.includes(group),
    );
  }

  return currentUserInterfaceFlags.includes(interfaceFlags);
};
